import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import Prismic from 'helpers/Prismic';
import { globalPropsRequests } from 'utils/globalProps';
import Error from 'components/Error';
import Loader from 'components/Loader';
import { StorefrontContext } from 'providers/storefront';
import breakPoints, { colors } from 'helpers/Styles';
import Head from 'next/head';
import { Element } from 'react-scroll';
import ClearanceProduct from 'containers/CategoryLandingSlices/GamingProductList/clearanceProduct';
import ProductFilterClearance from 'components/ProductFilterClearance';
import Script from 'next/script';

const ClerancePage = ({ handle, menu, content }) => {
  const router = useRouter();
  const { isFallback } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  if (!content) {
    return <Error code={404} />;
  }

  const {
    og_description: ogDescription,
    og_image: ogImage,
    seo_title: seoTitle,
    seo_description: seoDescription,
    title,
    description,
    banner_title,
    body,
  } = content;

  const [filteredProducts, setFilteredProducts] = useState(null);
  const [search, setSearch] = useState(null);
  const { isMenuOpen, isAnnouncementBarOpen } = useContext(StorefrontContext);
  const buttonLabel = 'VIEW PRODUCT';
  const [totalCount, setTotalCount] = useState(0);
  const [filterCount, setFilterCount] = useState([]);
  const [activeFilter, setActiveFilter] = useState(0);
  const [sortActive, setSortActive] = useState('category');
  const [activeNav, setActiveNav] = useState({});
  const [action, setAction] = useState(false);
  const [count, setCount] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [titleField, setTitleField] = useState(null);

  let listTitles = [];
  let filterTotalCount = 0;

  const data = body.map((bodyItem) => {
    const val =
      typeof bodyItem.primary.filter !== 'undefined' &&
      bodyItem.primary.filter.split('-')[0];
    const value =
      typeof bodyItem.primary.filter !== 'undefined' &&
      bodyItem.primary.filter.split('-')[1];
    if (val && val !== 'style' && val !== 'value') {
      listTitles.push(val);
    }
  });

  useEffect(() => {
    const data = router.query;
    delete data.handle;

    if (
      data &&
      Object.keys(data).length != 0 &&
      !count &&
      !trigger &&
      filteredProducts !== null
    ) {
      if (typeof data.category !== 'undefined') {
        let paramsArr = data.category.split(',');
        paramsArr.map((itm) => {
          updateFilterCount(itm, 'category');
        });
      }
      setCount(true);
    }
    if (data && Object.keys(data).length !== 0) {
      let categoryData = [];
      const filterArray = handleFlatArray(body);
      const arr = filterArray;
      if (typeof data.category !== 'undefined') {
        let paramsArr = data.category.split(',');
        paramsArr?.map((el) => {
          filterArray.filter((itm) => {
            const { product } = itm;
            const productTags =
              product &&
              typeof product.tags !== 'undefined' &&
              product.tags.split(',');
            const filterTags =
              productTags &&
              productTags.filter((item) => item.trim().startsWith('category:'));
            const category =
              filterTags &&
              filterTags.length > 0 &&
              filterTags[0].split(':')[1];

            if (
              category &&
              category.replace(/ /g, '').toLowerCase() ===
                el.replace(/ /g, '').toLowerCase()
            )
              return categoryData.push(itm);
          });
        });
      }
      let filterData =
        categoryData.length > 0 ? categoryData : handleFlatArray(body);

      if (categoryData.length > 0) {
        filterData = categoryData;
      } else if (typeof data?.category !== 'undefined') {
        filterData = categoryData;
      }

      let latestArray = filterData;
      setFilteredProducts(latestArray);
    } else if (
      Object.keys(data).length === 0 &&
      filteredProducts != null &&
      action
    ) {
      handleClearAll();
      setAction(false);
    } else {
      if (filteredProducts == null) {
        let flatProducts = handleFlatArray(body);
        setTotalCount(flatProducts.length);
        setFilteredProducts(flatProducts);
      }
    }
  }, [router.query, action]);

  filterTotalCount += filteredProducts != null ? filteredProducts.length : 0;

  const handleFlatArray = (arr) => {
    let filteredItems = arr.map((bodyItem) => {
      return bodyItem.items;
    });
    let filtered = filteredItems.map((el) => {
      return el.filter(
        (itm) => itm.product !== null && typeof itm.product !== 'undefined',
      );
    });

    const flatProducts = filtered.flat();
    flatProducts.filter((el) => el.product !== null);

    return flatProducts;
  };

  const handleActiveNav = async (index, type, item, action = null) => {
    setTrigger(true);
    if (action) {
      const data = router.query;
      delete data.handle;
      let params = data[type];
      if (typeof params !== 'undefined') {
        const arr = params.split(',');
        let filterArr = [];
        arr.map((itm) => {
          itm !== item.toLowerCase() && filterArr.push(itm);
        });
        params = filterArr.join();
      }

      if (params == '') {
        delete data[type];
        setAction(true);
        router.push(
          {
            pathname: `/collection/${handle}`,
            query: { ...data },
          },
          undefined,
          { shallow: true },
        );
      } else {
        router.push(
          {
            pathname: `/collection/${handle}`,
            query: { ...data, [type]: params.toLowerCase() },
          },
          undefined,
          { shallow: true },
        );
      }
      updateFilterCount(item.toLowerCase(), type, 'remove');
    } else {
      const data = router.query;
      delete data.handle;
      if (type === 'category') {
        let params = data[type];

        if (typeof params !== 'undefined') {
          params = params + ',' + item;
        } else {
          params = item;
        }
        router.push(
          {
            pathname: `/collection/${handle}`,
            query: {
              ...data,
              [type]: params.toLowerCase(),
            },
          },
          undefined,
          { shallow: true },
        );
      }
      updateFilterCount(item.toLowerCase(), type);
    }
  };

  const closeFilters = () => {
    setActiveFilter(!activeFilter);
  };

  const handleClearAll = () => {
    const latestArray = handleFlatArray(body);
    setFilteredProducts(latestArray);
    router.push(
      {
        pathname: `/collection/${handle}`,
      },
      undefined,
      { shallow: true },
    );
    setFilterCount([]);
    setTitleField({
      filter: '',
      title,
      description,
    });
  };

  const updateFilterCount = async (item, type, action = null) => {
    if (action) {
      let newitems = filterCount.filter((el) => el != item);
      setFilterCount(newitems);
    } else {
      if (!filterCount.includes(item)) {
        filterCount.push(item);
        setFilterCount(filterCount);
      }
    }
  };

  return (
    <>
      <Head>
        <link
          rel="preconnect dns-prefetch"
          href="https://triplewhale-pixel.web.app/"
          crossorigin
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://api.config-security.com/"
          crossorigin
        />
        <script> TripleHeadless = "aftershockpcsg.myshopify.com" </script>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:description" content={ogDescription} />
        <meta
          property="og:image"
          content={
            ogImage?.url
              ? ogImage?.url
              : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
          }
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1024" />
      </Head>
      <Script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID}');`,
        }}
        strategy="lazyOnload"
      />
      <main>
        <div className="main-wrapper">
          <div
            className="headerFilter wrapper wrapp_filter"
            onClick={() => closeFilters()}
          >
            <div>
              <span className="filterLabel">{totalCount} PRODUCTS </span>
            </div>
            <div className="filterLabel filterLabel-filter">
              <img
                src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-filter.png?v=1713809210"
                alt="first_level menu"
                layout="fixed"
                width={15}
                height={15}
              />
              <span className="filterLabel filterLabel-filter">
                FILTER & SORT
              </span>
              <span className="filterLabel-filters-count">
                {filterCount.length}
              </span>
            </div>
          </div>
          {activeFilter && (
            <div className="header">
              <div className="cross" onClick={() => closeFilters()}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                    fill="#E4E4E4"
                  />
                </svg>
              </div>
              <div className="filtersBtn">
                <div className="inner_btns">
                  <button
                    onClick={() => handleSortActive('category')}
                    className={sortActive == 'category' ? 'active' : ''}
                  >
                    CATEGORY
                  </button>
                </div>
                <div className="our_btns">
                  {sortActive === 'category' &&
                    (listTitles.length > 0 ? (
                      listTitles.map((item, listIndex) => (
                        <ProductFilterClearance
                          item={item}
                          listIndex={listIndex}
                          key={item}
                          type={sortActive}
                          handleActiveNav={handleActiveNav}
                          activeNav={activeNav}
                        />
                      ))
                    ) : (
                      <p>No product filter available </p>
                    ))}
                </div>
                <div className="results">
                  <label>{filterTotalCount} results</label>
                  <div className="results-divider"></div>
                  <label className="clear">
                    <span>{filterCount.length}</span>
                    <a
                      href="javascript:void(0);"
                      className="clearFilter"
                      onClick={() => handleClearAll()}
                    >
                      Clear Filters
                    </a>
                  </label>
                </div>
              </div>
              <div className="filtersBtn__mobile">
                <div className="our_btns">
                  <label className="clear">
                    <span>{filterCount.length}</span>
                    <a
                      href="javascript:void(0);"
                      className="clearFilter"
                      onClick={() => handleClearAll()}
                    >
                      Clear Filters
                    </a>
                  </label>
                  <div className="our_btns-item-mobile">
                    <h1 className="our_btns-item-title">CATEGORY</h1>
                    {listTitles.map((item, listIndex) => (
                      <ProductFilterClearance
                        item={item}
                        listIndex={listIndex}
                        key={item}
                        type={'category'}
                        handleActiveNav={handleActiveNav}
                        activeNav={activeNav}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeFilter && (
            <div className="results results-mobile">
              <label onClick={() => closeFilters()}>
                APPLY - {filterTotalCount} RESULTS
              </label>
            </div>
          )}
        </div>
        <div className="wrapper">
          <div className="search-section">
            <div className="search-container">
              <input
                placeholder="Search by product name..."
                className="search-bar"
                onChange={(e) => setSearch(e.target.value)}
              />
              <button className="search-icon">
                <img
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-search.svg?v=1713944974"
                  alt="icon-search"
                />
              </button>
            </div>
          </div>
          <div className="tabContent">
            <div className="gaming_product_list anchor-container">
              {filteredProducts != null && filteredProducts.length > 0 ? (
                <Element name="TEST" className="element">
                  <ClearanceProduct
                    key={'a'}
                    data={
                      search
                        ? filteredProducts.filter((item) =>
                            item.product.title
                              .toLowerCase()
                              .includes(search.toLowerCase()),
                          )
                        : filteredProducts
                    }
                    buttonLabel={buttonLabel}
                    fixedPrice
                    readyToShip
                    title={banner_title[0].text}
                    description={description}
                  />
                </Element>
              ) : (
                <p className="text-center"> No Result Found</p>
              )}
            </div>
          </div>
        </div>
      </main>
      <style jsx>
        {`
          .results label {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            text-align: right;
            font-family: 'Roboto-Medium';
            color: #949494;
          }
          .icons {
            display: flex;
            align-items: center;
            width: 48px;
            justify-content: space-between;
          }
          .results-divider {
            width: 1px;
            height: 32px;
            background: #242424;
          }

          .results label span {
            color: #fff;
            text-align: center;
          }

          .our_btns-item-mobile {
            text-align: left;
          }

          .our_btns-item-title {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            color: #949494;
            margin-top: 32px;
            margin-bottom: 16px;
          }

          .clear a {
            color: #fff;
          }
          .text-center {
            text-align: center;
          }
          .headerFilter {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            cursor: pointer;
          }

          .filterLabel {
            font-style: normal;
            font-size: 13px;
            line-height: 24px;
            cursor: pointer;
            font-weight: 400;
            color: #949494;
            text-align: center;
          }

          .filterLabel-filter {
            color: #e4e4e4;
          }
          .filterLabel-filters-count {
            width: 20px;
            height: 20px;
            background: #950810;
            display: inline-block;
            border-radius: 50%;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            margin-right: 12px;
            margin-left: 8px;
            text-align: center;
          }

          label.clear span {
            width: 20px;
            height: 20px;
            background: #950810;
            display: inline-block;
            border-radius: 50%;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            margin-right: 12px;
          }
          label.clear button {
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            text-decoration-line: underline;
          }
          .cross {
            position: absolute;
            top: 17px;
            right: 17px;
            display: inline-block;
            cursor: pointer;
          }
          .results {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            max-width: 275px;
            margin: 1% auto 0px;
          }
          .filtersBtn,
          .filtersBtn__mobile {
            text-align: center;
          }
          .filtersBtn__mobile {
            display: none;
          }
          .filtersBtn__mobile .clear {
            display: flex;
          }
          @media (max-width: ${breakPoints.mobileExtraLarge}) {
            .filtersBtn {
              display: none;
            }
            .filtersBtn__mobile {
              display: block;
            }
          }

          .clearFilter {
            text-decoration: underline;
          }
          .inner_btns button {
            background: transparent;
            color: #e4e4e4;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            border-radius: 2px;
            padding: 2px 8px;
            border: none;
            margin-right: 7px;
            font-family: 'Roboto-Medium';
            opacity: 0.75;
          }

          .inner_btns button.active {
            background: #950810;
            opacity: 1;
          }
          .inner_btns {
            width: 100%;
            display: inline-block;
            margin-bottom: 2%;
          }
          .filterBtn {
            padding: 65px;
          }
          .headerFilter img {
            filter: invert(0.5);
            width: 19px;
            height: auto;
            position: relative;
            top: 2px;
            right: 11px;
          }

          .headerFilter {
            display: flex;
            justify-content: space-between;
            padding: 15px;
          }
          .main-wrapper {
            padding-bottom: ${activeFilter ? '24px' : '0'};
            background-color: #141414;
            height: ${activeFilter ? 'unset' : '54px'};
            overflow: ${activeFilter ? 'unset' : 'hidden'};
            position: ${isMenuOpen ? 'unset' : 'sticky'};
            top: 64px;
            z-index: 3;
          }

          .main-wrapper .wrapp_filter {
            max-width: 1440px;
            padding-left: 48px;
            padding-right: 48px;
          }

          @media (max-width: ${breakPoints.mobileM}) {
            .wrapp_filter {
              padding-left: 15px !important;
              padding-right: 10px !important;
            }
          }

          .main-wrapper .header {
            padding: 50px 15px;
            background-color: #040404;
            position: relative;
            width: 75%;
            margin: auto;
            border-radius: 4px;
          }

          .header .cross {
            text-align: right;
          }

          .tabContent {
            display: flex;
          }
          .sticky_list {
            flex: 1;
          }
          .sticky_list ul {
            position: sticky;
            top: 100px;
            padding-top: 50px;
            padding-right: 10px;
            list-style-type: none;
            margin-bottom: 0px;
            padding-bottom: 16px;
            padding-left: 0px;
          }

          .gaming_product_list {
            flex: 3;
            display: flex;
            flex-direction: column;
            margin-left: auto;
          }
          .active_link button {
            background-color: ${colors.brandSecondary};
            font-family: 'Roboto-Bold';
          }
          .button_arrow {
            padding: 15px 20px;
            background-color: #242424;
          }
          main {
            background-color: ${colors.n500};
          }
          @media (max-width: ${breakPoints.medium}) {
            .main-wrapper {
              top: ${isAnnouncementBarOpen ? '78px' : '46px'};
            }

            .tabContent {
              flex-direction: column;
              justify-content: center;
            }
            .gaming_product_list {
              width: 100%;
            }
            .sticky_list {
              position: sticky;
              top: 32px;
              background-color: black;
              z-index: 1;
            }
            .sticky_list ul {
              white-space: nowrap;
              overflow-x: scroll;
              padding-top: 10px;
              display: flex;
            }
          }

          .bottom_info {
            padding: 60px 0 80px 0;
            color: #e4e4e4;
            font-family: 'Roboto-Light';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            width: 30%;
            justify-content: center;
            margin: auto;
          }

          .results-mobile {
            display: none;
          }

          @media (max-width: ${breakPoints.medium}) {
            .bottom_info {
              width: 100%;
            }
          }
          @media (max-width: ${breakPoints.small}) {
            .main-wrapper .header {
              width: 100%;
            }
          }

          @media (max-width: ${breakPoints.mobileExtraLarge}) {
            .main-wrapper {
              position: ${activeFilter ? 'unset' : 'sticky'};
            }

            .main-wrapper .header {
              position: absolute;
              background-color: #141414;
              top: 0;
              left: 0;
              z-index: 22;
              height: 100vh;
              width: 100vw;
              display: flex;
              flex-direction: column;
              justify-content: center;
              overflow-y: scroll;
              padding-bottom: 110px;
            }

            .results-mobile {
              display: flex;
              width: 100%;
              max-width: 540px !important;
              position: fixed;
              bottom: 0;
              z-index: 100;
              border-top: 1px solid #646464;
              margin: 0px auto;
              overflow: hidden;
              background-color: #141414;
            }

            .results-mobile > label {
              width: 100%;
              max-width: 237px;
              text-align: center;
              padding: 12px 0;
              background: #950810;
              color: #e4e4e4;
              margin-top: 23px;
              margin-bottom: 24px;
              border-radius: 4px;
              cursor: pointer;
            }
          }

          @media (max-width: 450px) and (max-height: 740px) {
            .filtersBtn__mobile {
              padding-top: 80px;
            }

            .main-wrapper {
              top: ${isAnnouncementBarOpen ? '78px' : '46px'};
            }
          }
          @media (max-width: 300px) {
            .filtersBtn__mobile {
              padding-top: 725px;
            }
          }
          @media (max-width: 280px) {
            .filtersBtn__mobile {
              padding-top: 845px;
            }
          }

          @media (max-width: 425px) {
            .sticky_list::after {
              content: '';
              width: 60px;
              background: linear-gradient(
                to left,
                rgba(0, 0, 0, 1),
                rgba(0, 0, 0, 0.2)
              );
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
            }
            .cross.jsx-2980388124 {
              right: 48px;
            }
          }
          .search-section {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 4%;
          }
          .search-container {
            position: relative;
            width: 50%;
          }
          .search-bar {
            font-family: 'Roboto-Medium';
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;
            background: #141414;
            border: 1px solid#242424;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            padding: 14px 16px;
            width: 100%;
            height: 48px;
            color: #e4e4e4;
            padding-right: 48px;
          }
          .search-icon {
            background: none;
            border: none;
            user-select: none;
            position: absolute;
            right: 0;
            height: 48px;
            width: 48px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
          }
          @media (max-width: 850px) {
            .search-container {
              width: 90%;
            }
          }
        `}
      </style>
    </>
  );
};

export async function getStaticProps({ params, preview = false, previewData }) {
  const { handle } = params;
  const { ref } = previewData || {};
  const global = {};

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  const content = await Prismic.getByUID(
    'clearance_page',
    `${handle}`,
    ref ? { ref } : null,
  );

  if (!content) {
    return { notFound: true };
  }

  return {
    props: {
      global,
      content: content?.data || null,
      preview,
      handle,
    },
    revalidate: 3600,
  };
}

export async function getStaticPaths() {
  return {
    paths: [{ params: { handle: 'clearance' } }],
    fallback: true,
  };
}

export default ClerancePage;
